// import _ from 'lodash';
import * as types from 'constants/ActionTypes';
import { custom, listWM } from 'utils/Api';
import trim from 'lodash/trim';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import unionWith from 'lodash/unionWith';
import groupBy from 'lodash/groupBy';
import filter from 'lodash/filter';
import get from 'lodash/get';
import map from 'lodash/map';
import compact from 'lodash/compact';

export function requestSearch(query) {
  return {
    type: types.SEARCH_REQUEST,
    query,
  };
}

export function requestSearchSuccess(resultData) {
  return {
    type: types.SEARCH_REQUEST_SUCCESS,
    resultData,
  };
}

export function requestSearchSuccessAll(resultData) {
  return {
    type: types.SEARCH_REQUEST_SUCCESS_ALL,
    resultData,
  };
}

export function requestSearchFailure(error) {
  return {
    type: types.SEARCH_REQUEST_FAILURE,
    error,
  };
}

export function requestSearchClear() {
  return {
    type: types.SEARCH_REQUEST_CLEAR,
  };
}

export function fetch(search) {
  return (dispatch, getState) => {
    const searchstring = search.replace(/:\s*/, ':');
    dispatch(requestSearch(searchstring));
    const { EmployeeSearch: { query }, loginReducer: { user: { token } } } = getState();
    const config = {
      url: 'api/HrData/EmployeesSearch',
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      params: {
        searchstring,
      },
    };

    return custom(config)
      .then(res => query === searchstring && dispatch(requestSearchSuccessAll(res.data)))
      .catch(err => dispatch(requestSearchFailure(err)));
  };
}

export function fetchByQualification(searchstring, qualificationTypes) {
  return (dispatch, getState) => {
    dispatch(requestSearch(searchstring));
    if (!searchstring) {
      return dispatch(requestSearchSuccess([]));
    }
    const { /* EmployeeSearch: { query }, */ loginReducer: { user: { token } } } = getState();
    const qualifications = searchstring.split(',').filter(x => !isEmpty(x));
    const qualificationTypesList = qualificationTypes ? qualificationTypes.split`,`.filter(x => !isEmpty(x)) : [];
    const config = {
      entity: 'EmployeeMasterQualification',
      headers: { Authorization: `Bearer ${token}` },
      params: {
        $filter: `${qualifications.map(q => `indexof(tolower(QualificationName), tolower('${trim(q)}')) ge 0`).join` or `} ${qualificationTypes.length === 0 ? '' : `and (${qualificationTypesList.map(q => `Entity/QualificationType eq ${q}`).join` or `})`}`,
        $expand: 'Entity',
        $select: 'Entity/EmployeeMasterID,QualificationName',
      },
    };
    return listWM(config)
      .then(({ data }) => {
      /* Fetch all the qualifications that matched the search and filter out
          the EmployeeMasterIDs of the employess that have all the
          qualifications searched for.
          */
        const employees = map(filter(
          groupBy(unionWith(data, isEqual), 'EmployeeMasterID'),
          x => x.length >= qualifications.length,
        ), x => get(x, '[0].EmployeeMasterID'));
        // If we had no employess that cover all qualifications we return nothing.
        if (employees.length === 0) {
          dispatch(requestSearchSuccessAll([]));
        } else {
          const all = map(employees, emID => custom({
            url: 'api/HrData/EmployeesSearch',
            headers: { Authorization: `Bearer ${token}` },
            method: 'GET',
            params: {
              searchstring: `ID:${emID}`,
            },
          }));
          Promise.all(all)
          /*
          We fetch all the users that matched the required qualifications.
        */
            .then(res => dispatch(requestSearchSuccess(compact(map(res, (r) => {
              if (r.data && r.data.length) {
                return r.data[0];
              }
              return undefined;
            })))))
            .catch(error => dispatch(requestSearchFailure(error)));
        }
      })
      .catch(error => dispatch(requestSearchFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/EmployeeSearch.js